import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Paper, Grid } from '@material-ui/core';
import { Typography, Card, IconButton } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';


import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// import PerfectScrollbar from 'react-perfect-scrollbar';


import UpdateForm from './UpdateForm'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  gridContainerOuter: {
    margin: '6px -6px',
    display: 'flex',
    justifyContent: 'center'
  },
  gridItemInner: {
    padding: '0px 6px',
    width: '100%'
  },
  table: {
    minWidth: 650,
  },

  trRow: {
    '& td': {
      padding: 6
    }
  },
  dialogTitle: {
    '& h2': {
      width: '100%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  titleDiv: {
    padding: '8px 0px 12px 0px'
  },
  cardDiv: {
    display: 'flex',
    flex: 1,
  }
});

const ordersData = [{
  orderId: '#9101',
  invoice: 'INV-001001',
  customer: 'William Joy',
  email: 'William@example.com',
  profit: '$120',
  status: 'pending',
},
{
  orderId: '#9102',
  invoice: 'INV-001002',
  customer: 'Thomas Arin',
  email: 'Thomas@example.com',
  profit: '$210',
  status: 'pending',
},
{
  orderId: '#9103',
  invoice: 'INV-001003',
  customer: 'James Smith',
  email: 'James@example.com',
  profit: '$452.50',
  status: 'pending',
},
{
  orderId: '#9104',
  invoice: 'INV-001004',
  customer: 'James Johnson',
  email: 'Johnson@example.com',
  profit: '$400',
  status: 'pending',
},
{
  orderId: '#9105',
  invoice: 'INV-001005',
  customer: 'Maria Hernandez',
  email: 'Hernandez@example.com',
  profit: '$506.50',
  status: 'pending',
}
]

export default function Customers() {
  const classes = useStyles();

  const [orders, setOrders] = useState(ordersData)
  const [deleteConfirmOpen, setdeleteConfirmOpen] = useState(false)
  const [selected, setSelected] = useState();
  const [openEditModal, setopenEditModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState({});

  const editHandler = (row) => {
    console.log('editHandler', row)
    setopenEditModal(true);
    setSelectedRow(row)
  }
  const editHandleClose = (val) => {
    if (val === "update") {
      setopenEditModal(false)
    } else {
      setopenEditModal(false)
    }
  }

  const submithandlerProp = (val) => {
    console.log("received")
    console.log(val)
    console.log(selectedRow)
    console.log(selectedRow.orderId)
    let orders_updated = orders.map(x => x.orderId === selectedRow.orderId ? { ...selectedRow, ...val } : x);
    setOrders(orders_updated)
    setopenEditModal(false)
  }



  const deleteHandler = (id) => {
    console.log('deleteHandler', id)
    setSelected(id)
    setdeleteConfirmOpen(true)
  }

  const deleteHandleClose = (val) => {
    if (val === "yes") {
      let orders_ = orders.filter(({ orderId }) => orderId != selected)
      setOrders(orders_)
      setdeleteConfirmOpen(false)
    } else {
      setdeleteConfirmOpen(false)
    }
  }




  return (

    <div className={classes.root}>


      <div className={classes.titleDiv}>
        <Typography variant="h2">Customers</Typography>
      </div>
      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardDiv}>

            <TableContainer >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>orderId</TableCell>
                    <TableCell >invoice</TableCell>
                    <TableCell >customer</TableCell>
                    <TableCell >profit</TableCell>
                    <TableCell align="center">status</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  {orders.map((row) => (
                    <TableRow key={row.orderId} className={classes.trRow}
                      hover
                    >
                      <TableCell component="th" scope="row">
                        {row.orderId}
                      </TableCell>
                      <TableCell >{row.invoice}</TableCell>
                      <TableCell >
                        {row.customer}
                        <p>{row.email}</p>
                      </TableCell>
                      <TableCell >{row.profit}</TableCell>
                      <TableCell align="center">{row.status}</TableCell>
                      <TableCell align="center">
                        <IconButton onClick={() => editHandler(row)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => deleteHandler(row.orderId)}>
                          <DeleteForeverIcon />
                        </IconButton>
                      </TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          </Card>
        </Grid>

        <Dialog
          open={deleteConfirmOpen}
          onClose={() => deleteHandleClose('')}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              Are you sure, do you want to delete!
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => deleteHandleClose('yes')} color="primary">
              yes
          </Button>
            <Button onClick={() => deleteHandleClose('no')} color="secondary" autoFocus>
              no
          </Button>
          </DialogActions>
        </Dialog>


        <Dialog onClose={() => editHandleClose('')} aria-labelledby="customized-dialog-title" open={openEditModal}>
          <DialogTitle id="customized-dialog-title" className={classes.dialogTitle}>
            Edit Customer
          <IconButton onClick={() => editHandleClose('')} style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {/* <Typography gutterBottom>
           {JSON.stringify(selectedRow)}
          </Typography> */}

            <UpdateForm customer={selectedRow} submithandlerProp={(val) => submithandlerProp(val)} />
          </DialogContent>

        </Dialog>

      </Grid>
    </div>
  );
}